<mat-drawer-container [hasBackdrop]="true" autosize>
  <div class="body-container" [ngClass]="{ 'full-screen': avoidPrefix }">
    <div class="sidenav-toggle-btn d-flex gap-1 w-10" [ngClass]="{ 'sidenav-toggle-sm': toggleCompanyLogo }">
      @if (!avoidPrefix && toggleCompanyLogo) {
        <button mat-icon-button class="side-bar-toggle m-auto" (click)="dynamicSideNav.toggle()"><mat-icon class="text-light">menu</mat-icon></button>
      }
    </div>
    <div class="header-section w-100" [ngClass]="{ 'header-section-sm': toggleCompanyLogo }">
      <mobi-office-lib-header-section [isMagicBellVisible]="true" [isProfileSettingVisible]="true" (logoutEmitter)="onLogOut()" (logoClickEmitter)="onLogoClick()"></mobi-office-lib-header-section>
    </div>
    <div class="main-section">
      <div class="aside-section">
        @if (!toggleCompanyLogo) {
          <mobi-office-lib-aside-section (tabEmitter)="onTabChange($event)" [menuItems]="sideMenus$ | async" [isExpandable]="true"></mobi-office-lib-aside-section>
        }
      </div>
      <div class="body-section">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>

  <!-- Dynamic Mat Drawer -->
  <mat-drawer #dynamicSideNav class="panel" mode="over" position="end">
    <mobi-office-custom-aside-section [menuItems]="sideMenus$ | async"></mobi-office-custom-aside-section>
  </mat-drawer>
</mat-drawer-container>

<!-- Loader -->
<mobi-office-lib-loader [loader]="showSpinner"></mobi-office-lib-loader>
